import { useFormContext } from "react-hook-form";

import {
  InputDateControllerRow,
  InputTextAreaRow,
  InputTextRow,
} from "@components";

import {
  BASIC_INFO,
  TerminationFormDataType,
} from "@validations/HRM/termination/terminationFormValidation";

export const BasicInfo = ({ isDisabled }: { isDisabled: boolean }) => {
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext<TerminationFormDataType>();

  return (
    <div className="d-flex flex-column gap-8 pb-8">
      <InputTextRow
        label="TERMINATION_DETAILS.FORM.BASIC_INFO.NAME"
        register={{ ...register(BASIC_INFO.NAME) }}
        error={errors as any}
        disabled
      />
      <InputDateControllerRow
        label="TERMINATION_DETAILS.FORM.BASIC_INFO.DATE_OF_TERMINATION"
        control={control}
        register={{ ...register(BASIC_INFO.TERMINATE_DATE) }}
        errors={errors as any}
        name={BASIC_INFO.TERMINATE_DATE}
        required
        disabled={isDisabled}
      />
      <InputTextAreaRow
        label="TERMINATION_DETAILS.FORM.BASIC_INFO.REASON_FOR_TERMINATION"
        register={{ ...register(BASIC_INFO.TERMINATE_REASON) }}
        error={errors as any}
        disabled={isDisabled}
      />

      <InputTextAreaRow
        label="TERMINATION_DETAILS.FORM.BASIC_INFO.DESCRIPTION"
        register={{ ...register(BASIC_INFO.DESCRIPTION) }}
        error={errors as any}
        disabled={isDisabled}
      />
    </div>
  );
};
